export default __webpack_public_path__ + "media/Objective/Objective-Medium-Italic-c80bcdd83ec66421a9248304743aad63.woff2";